/**
 * Mega menu — full-width desktop dropdown behavior
 */
(function () {
  'use strict';

  function initMegaMenu(nav) {
    var megaItems = nav.querySelectorAll('[data-mega-menu-item][data-item-type="mega"]');
    var header = nav.closest('[data-header]');
    var openItem = null;
    var openTimer = null;
    var closeTimer = null;
    var OPEN_DELAY_MS = 180;
    var CLOSE_DELAY_MS = 220;

    if (!megaItems.length) return;

    function syncPanelMetrics() {
      var anchor = header || nav;
      var rect = anchor.getBoundingClientRect();
      var panelTop = Math.max(Math.round(rect.bottom), 0);
      var viewportHeight = window.visualViewport && window.visualViewport.height
        ? window.visualViewport.height
        : window.innerHeight;
      var availableHeight = Math.max(Math.floor(viewportHeight - panelTop), 120);
      nav.style.setProperty('--mega-menu-panel-top', panelTop + 'px');
      nav.style.setProperty('--mega-menu-panel-max-height', availableHeight + 'px');
    }

    function closeItem(li) {
      if (!li) return;

      var trigger = li.querySelector('.mega-menu__trigger');
      var panel = li.querySelector('.mega-menu__panel');

      li.removeAttribute('data-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.setAttribute('aria-hidden', 'true');

      if (openItem === li) openItem = null;
    }

    function closeAll() {
      megaItems.forEach(function (li) {
        closeItem(li);
      });
    }

    function clearOpenTimer() {
      if (openTimer) {
        clearTimeout(openTimer);
        openTimer = null;
      }
    }

    function clearCloseTimer() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function closeAllImmediate() {
      clearOpenTimer();
      clearCloseTimer();
      closeAll();
    }

    function openItemFn(li) {
      if (!li || li.getAttribute('data-item-type') !== 'mega') return;

      var trigger = li.querySelector('.mega-menu__trigger');
      var panel = li.querySelector('.mega-menu__panel');
      if (!trigger || !panel) return;

      syncPanelMetrics();

      if (openItem && openItem !== li) {
        closeItem(openItem);
      }

      openItem = li;
      li.setAttribute('data-open', 'true');
      trigger.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
    }

    function scheduleOpen(li) {
      if (!li || li.getAttribute('data-item-type') !== 'mega') return;
      clearCloseTimer();
      clearOpenTimer();
      openTimer = setTimeout(function () {
        openTimer = null;
        openItemFn(li);
      }, OPEN_DELAY_MS);
    }

    function scheduleCloseAll() {
      clearOpenTimer();
      clearCloseTimer();
      closeTimer = setTimeout(function () {
        closeTimer = null;
        closeAll();
      }, CLOSE_DELAY_MS);
    }

    megaItems.forEach(function (li) {
      var trigger = li.querySelector('.mega-menu__trigger');
      if (!trigger) return;

      li.addEventListener('mouseenter', function () {
        scheduleOpen(li);
      });

      li.addEventListener('mouseleave', function () {
        scheduleCloseAll();
      });
    });

    /* Hover open with delay; close when pointer leaves mega-menu region */
    nav.addEventListener('mouseenter', function () {
      clearCloseTimer();
    });

    nav.addEventListener('mouseleave', function () {
      scheduleCloseAll();
    });

    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) {
        closeAllImmediate();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeAllImmediate();
      }
    });

    window.addEventListener('resize', function () {
      syncPanelMetrics();
    });

    window.addEventListener(
      'scroll',
      function () {
        if (openItem) {
          syncPanelMetrics();
        }
      },
      { passive: true }
    );

    if (window.visualViewport && typeof window.visualViewport.addEventListener === 'function') {
      window.visualViewport.addEventListener('resize', syncPanelMetrics);
      window.visualViewport.addEventListener('scroll', syncPanelMetrics);
    }

    syncPanelMetrics();
  }

  function init() {
    document.querySelectorAll('[data-mega-menu]').forEach(initMegaMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
